import React from 'react';
import { Router, browserHistory } from 'react-router';
import { requireAuthentication } from './AuthenticatedComponent';

const rootRoute = {
	childRoutes: [ {
		path: '/',
		component: require('./components/Base').default,
		getIndexRoute(partialNextState, callback) {
			require.ensure([], function(require) {
				callback(null, {
					component: requireAuthentication(require('./routes/Home').default, 'any')
				})
			})
		},
		getChildRoutes(partialNextState, callback) {
			require.ensure([], function(require) {

				callback(null, [
					require('./routes/Unauthorized'),
					require('./routes/Login'),
					require('./routes/Logout'),
					require('./routes/Home'),
					require('./routes/Profile'),
					require('./routes/Accounts'),
					require('./routes/Users'),
					require('./routes/Regions'),
					require('./routes/Employees'),
					require('./routes/Requests'),
					require('./routes/BlockedDays'),
				])
			})
		}
	}]
}

const App = () => (
	<Router routes={rootRoute} history={browserHistory} />
);

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/